"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const __1 = require("../..");
const PopoverContent = ({ lists, onSelected }) => {
    const [searchKeyword, setSearchKeyword] = React.useState('');
    const [isSearchFocused, setIsSearchFocused] = React.useState(false);
    const filteredLists = searchKeyword !== ''
        ? lists.filter(({ name }) => name.toLowerCase().includes(searchKeyword.toLowerCase()))
        : lists;
    return (React.createElement("div", { style: {
            minHeight: 296,
            minWidth: 384,
            maxHeight: 520,
            display: 'flex',
            flexDirection: 'column',
        } },
        React.createElement(__1.PopoverSearch, { device: 'Desktop', isSearchFocused: isSearchFocused, removeFocus: () => setIsSearchFocused(false), setFocus: () => setIsSearchFocused(true), text: searchKeyword, submitText: s => setSearchKeyword(s) }),
        React.createElement("div", { style: {
                flex: '1 1 auto',
                overflowY: 'scroll',
                paddingBottom: 0,
            } },
            React.createElement(__1.SelectableList, { device: "Desktop" }, filteredLists.map((list, index) => {
                return (React.createElement("div", { key: index, onClick: () => onSelected && onSelected(list), style: {
                        height: 55,
                        paddingTop: 16,
                    } },
                    React.createElement(__1.Text, { text: list.name, size: "large" })));
            })))));
};
const AutomatedListSelectorModal = ({ targetParent, lists, onSelected }) => {
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const togglePopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };
    return (React.createElement(__1.PopoverContainer, { onClick: togglePopover, popoverProps: {
            placement: 'right',
            navBarProperties: {
                title: 'Automated Lists',
                buttonLeft: 'Cancel',
                buttonLeftCallback: togglePopover,
            },
        }, targetParent: targetParent, showPopover: isPopoverOpen },
        React.createElement(__1.FileSelectIcon, { fill: __1.turquoise }),
        React.createElement(PopoverContent, { lists: lists, onSelected: onSelected })));
};
exports.default = AutomatedListSelectorModal;
